const userMainDataValidationScheme = {
  name: ['required', 'maxLength128'],
  email: ['required', 'maxLength128', 'email'],
  userMainDataOrganizationLength: ['notEmptyUserMainDataOrganizationsArr'],
};
export default userMainDataValidationScheme;